import {
  RESIDENTIAL_INDICATOR_DEFAULT_BEHAVIOR,
  RESIDENTIAL_INDICATOR_MARKETPLACE_FALLBACK_BEHAVIOR,
  COMMERCIAL_INDICATOR,
} from './general-settings-tab/constants';

/**
 * Default store settings
 * This object contains all default settings that should be applied to a store
 * when they don't already exist in the store data
 */
export const DEFAULT_STORE_SETTINGS = {
  // Residential/Commercial indicator defaults
  [RESIDENTIAL_INDICATOR_DEFAULT_BEHAVIOR]: COMMERCIAL_INDICATOR,
  [RESIDENTIAL_INDICATOR_MARKETPLACE_FALLBACK_BEHAVIOR]: COMMERCIAL_INDICATOR,

  // Future settings can be added here
  // SOME_NEW_SETTING: 'default value',
};

/**
 * Applies default settings to store data
 * @param {object} storeData - The store data to apply defaults to
 * @returns {object} - The store data with default settings applied
 */
export const applyDefaultSettings = (storeData) => {
  if (!storeData) return storeData;

  // If storeData has no settings property, return the original data
  if (!storeData.settings) return storeData;

  const storeSettings = storeData.settings.storeSettings || [];
  const existingSettingNames = storeSettings.map((setting) => setting.name);

  // Create array of missing settings with default values
  const missingSettings = Object.entries(DEFAULT_STORE_SETTINGS)
    .filter(([settingName]) => !existingSettingNames.includes(settingName))
    .map(([name, value]) => ({ name, value }));

  // If no missing settings, return original data
  if (missingSettings.length === 0) return storeData;

  // Create new store data with defaults applied
  return {
    ...storeData,
    settings: {
      ...storeData.settings,
      storeSettings: [...storeSettings, ...missingSettings],
    },
  };
};
